import { LoginOptions } from "components/Login/LoginOptions";
import { Panel } from "components/Panel/Panel";
import { CenterPage } from "pages/PageTemplates";

export const LoginPage = () => {
  return (
    <CenterPage>
      <Panel padding="square">
        <LoginOptions />
      </Panel>
    </CenterPage>
  );
};
